import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=31da1ce4&scoped=true&lang=pug&"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js&"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LoaderOverlay.vue?vue&type=style&index=0&id=31da1ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31da1ce4",
  null
  
)

export default component.exports